import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString,
  Char__hashCode_impl_otmys1an6rit7zu1bt as Char__hashCode_impl_otmys,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { sequence2vgswtrxvqoa7 as sequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  flatMap1gb3cjy1dqv3d as flatMap,
  distinct17vua5ffe1cfv as distinct,
  toListx6x8nvfmvvht as toList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function appendCsvRows(_this__u8e3s4, sequence, config) {
  config = config === VOID ? Companion_getInstance().default_1 : config;
  // Inline function 'kotlin.sequences.forEach' call
  var _iterator__ex2g4s = sequence.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    appendCsvRow(_this__u8e3s4, element, config);
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.default_1 = new (CsvConfig())();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CsvConfigClass;
function CsvConfig() {
  if (CsvConfigClass === VOID) {
    class $ {
      constructor(fieldSeparator, recordSeparator, optionalRecordSeparatorPrefix, quoteCharacter, defaultValue, trimWhiteSpace) {
        Companion_getInstance();
        fieldSeparator = fieldSeparator === VOID ? _Char___init__impl__6a9atx(44) : fieldSeparator;
        recordSeparator = recordSeparator === VOID ? _Char___init__impl__6a9atx(10) : recordSeparator;
        optionalRecordSeparatorPrefix = optionalRecordSeparatorPrefix === VOID ? _Char___init__impl__6a9atx(13) : optionalRecordSeparatorPrefix;
        quoteCharacter = quoteCharacter === VOID ? _Char___init__impl__6a9atx(34) : quoteCharacter;
        defaultValue = defaultValue === VOID ? '' : defaultValue;
        trimWhiteSpace = trimWhiteSpace === VOID ? true : trimWhiteSpace;
        this.fieldSeparator_1 = fieldSeparator;
        this.recordSeparator_1 = recordSeparator;
        this.optionalRecordSeparatorPrefix_1 = optionalRecordSeparatorPrefix;
        this.quoteCharacter_1 = quoteCharacter;
        this.defaultValue_1 = defaultValue;
        this.trimWhiteSpace_1 = trimWhiteSpace;
        this.quoteCharacterString_1 = toString(this.quoteCharacter_1);
        this.quoteCharacterString2__1 = toString(this.quoteCharacter_1) + toString(this.quoteCharacter_1);
      }
      toString() {
        return 'CsvConfig(fieldSeparator=' + toString(this.fieldSeparator_1) + ', recordSeparator=' + toString(this.recordSeparator_1) + ', optionalRecordSeparatorPrefix=' + toString(this.optionalRecordSeparatorPrefix_1) + ', quoteCharacter=' + toString(this.quoteCharacter_1) + ', defaultValue=' + this.defaultValue_1 + ', trimWhiteSpace=' + this.trimWhiteSpace_1 + ')';
      }
      hashCode() {
        var result = Char__hashCode_impl_otmys(this.fieldSeparator_1);
        result = imul(result, 31) + Char__hashCode_impl_otmys(this.recordSeparator_1) | 0;
        result = imul(result, 31) + Char__hashCode_impl_otmys(this.optionalRecordSeparatorPrefix_1) | 0;
        result = imul(result, 31) + Char__hashCode_impl_otmys(this.quoteCharacter_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.defaultValue_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.trimWhiteSpace_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CsvConfig()))
          return false;
        var tmp0_other_with_cast = other instanceof CsvConfig() ? other : THROW_CCE();
        if (!(this.fieldSeparator_1 === tmp0_other_with_cast.fieldSeparator_1))
          return false;
        if (!(this.recordSeparator_1 === tmp0_other_with_cast.recordSeparator_1))
          return false;
        if (!(this.optionalRecordSeparatorPrefix_1 === tmp0_other_with_cast.optionalRecordSeparatorPrefix_1))
          return false;
        if (!(this.quoteCharacter_1 === tmp0_other_with_cast.quoteCharacter_1))
          return false;
        if (!(this.defaultValue_1 === tmp0_other_with_cast.defaultValue_1))
          return false;
        if (!(this.trimWhiteSpace_1 === tmp0_other_with_cast.trimWhiteSpace_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CsvConfig', CsvConfig);
    CsvConfigClass = $;
  }
  return CsvConfigClass;
}
function appendCsv(_this__u8e3s4, values, config) {
  config = config === VOID ? Companion_getInstance().default_1 : config;
  appendCsvRows(_this__u8e3s4, sequence(appendCsv$slambda(values, config)), config);
}
function appendCsvRow(_this__u8e3s4, row, config) {
  config = config === VOID ? Companion_getInstance().default_1 : config;
  var first = true;
  var _iterator__ex2g4s = row.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var value = _iterator__ex2g4s.next_20eer_k$();
    if (first) {
      first = false;
    } else
      _this__u8e3s4.append_58al37_k$(config.fieldSeparator_1);
    appendCsvEscaped(_this__u8e3s4, value, config);
  }
  _this__u8e3s4.append_58al37_k$(config.recordSeparator_1);
}
function appendCsvEscaped(_this__u8e3s4, value, config) {
  config = config === VOID ? Companion_getInstance().default_1 : config;
  if (contains(value, config.fieldSeparator_1) || contains(value, config.recordSeparator_1) || contains(value, config.quoteCharacter_1)) {
    _this__u8e3s4.append_58al37_k$(config.quoteCharacter_1);
    _this__u8e3s4.append_jgojdo_k$(replace(value, config.quoteCharacterString_1, config.quoteCharacterString2__1));
    _this__u8e3s4.append_58al37_k$(config.quoteCharacter_1);
  } else {
    _this__u8e3s4.append_jgojdo_k$(value);
  }
}
function appendCsv$slambda$lambda(it) {
  return it.get_keys_wop4xp_k$();
}
function appendCsv$slambda($values, $config) {
  return constructCallableReference(($this$sequence, $completion) => orPromise($completion, function *($completion) {
    var keys = toList(distinct(flatMap($values, appendCsv$slambda$lambda)));
    yield* $this$sequence.yield_3xhcex_k$(keys, $completion);
    // Inline function 'kotlin.sequences.forEach' call
    var _iterator__ex2g4s = $values.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(keys, 10));
      var _iterator__ex2g4s_0 = keys.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var item = _iterator__ex2g4s_0.next_20eer_k$();
        var tmp0_elvis_lhs = element.get_wei43m_k$(item);
        var tmp$ret$4 = tmp0_elvis_lhs == null ? $config.defaultValue_1 : tmp0_elvis_lhs;
        destination.add_utx5q5_k$(tmp$ret$4);
      }
      yield* $this$sequence.yield_3xhcex_k$(destination, $completion);
    }
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  appendCsvRows as appendCsvRows26y51byhnrjfx,
  appendCsv as appendCsvr9yu6rqb1co7,
  Companion_getInstance as Companion_getInstance1iw2ra7dwm7v5,
};
//endregion

//# sourceMappingURL=CsvConfig.mjs.map
